import { RootState } from "@/redux/store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

const useAddEdit = () => {
  const [activeTab, setActiveTab] = useState<string>("task-planning");
  const prevTaskData = useRef<any>(null);

  const onChangeTab = (currTab: string) => {
    setActiveTab(currTab);
  };

  const taskData = useSelector((state: RootState) => state.currentData.taskData);

  useEffect(() => {
    if (JSON.stringify(prevTaskData) != JSON.stringify(taskData)) {
      prevTaskData.current = taskData;
      setActiveTab("task-planning")
    }
  }, [taskData])

  return {
    activeTab,
    onChangeTab,
    taskData
  };
};

export default useAddEdit;
